import moment from 'moment';
import $parseDateFromString from "@/globalFunctions/dateFromString";

const mutations = {
  SET_RAGE_DEVICES_VALUES_MONTH(state, payload = {from: null, to: null}) {
    let from = payload.from;
    let to = payload.to;

    if (from === null || to === null) {
      to = new Date();
      from = moment(to).subtract(6, 'months').toDate();

      if (localStorage.devicesValuesRange) {
        let rangeFromLocalStorage = JSON.parse(localStorage.devicesValuesRange);

        if (rangeFromLocalStorage.from && rangeFromLocalStorage.to) {
          from = rangeFromLocalStorage.from;
          to = rangeFromLocalStorage.to;
        }
      }
    }

    localStorage.devicesValuesRange = JSON.stringify({
      to: to,
      from: from
    });

    state.rangeDevicesValuesMonth.from = from;
    state.rangeDevicesValuesMonth.to = to;
  },
  SET_DEVICES_VALUES(state, payload) {
    let devicesCanShow = payload.filter(d => !([4, 7].includes(d.actual_state)));

    let devicesGroups = [];
    let isElectricityGrouped = false;

    let electricityDevices = devicesCanShow.filter(d => [3, 4, 5].includes(d.type));
    let electricityDevicesUnique = [...new Set(electricityDevices.map(d => d.type))];

    if (electricityDevices.length) {
      if (electricityDevicesUnique.length === electricityDevices.length) {
        isElectricityGrouped = true;

        let type = 9997;

        if (electricityDevices.length === 3) {
          type = 9999;
        } else if (electricityDevices.length === 2) {
          type = 9998;
        }

        let group = {
          type: type,
          factory_number: electricityDevices[0].factory_number,
          next_checking_date: electricityDevices[0].next_checking_date,
          inactive: false,
        };

        electricityDevices.forEach((device, index) => {
          let values = device.values.map(v => {
            v.value = v.value === null ? '-' : String(v.value);
            return v;
          });

          if (index === 0) {
            group.values = values;
          } else {
            values.forEach(v => {
              let groupIndex = group.values.findIndex(groupValue => groupValue.month === v.month);
              group.values[groupIndex].value += '/' + v.value
            })
          }
        });
        devicesGroups.push(group);
      }
    }

    if (isElectricityGrouped) {
      devicesCanShow = devicesCanShow.filter(d => ![3, 4, 5].includes(d.type));
    }

    state.values = [...devicesCanShow, ...devicesGroups];
  },
  SET_BODY_TO_SEND_VALUES(state, {devices, settings}) {
    let devicesCanShow = devices.filter(d => !([4, 7].includes(d.actual_state)));

    devicesCanShow.map(device => {
      device.last_real_value = device.last_real_value === null ? null : device.last_real_value;

      if (!settings.includes(device.type)) {
        device.canSend = false;
        device.sendText = 'Получаем автоматически или снимаем со счетчиков сами';
      }
      else if([3].includes(device.actual_state)){
        device.canSend = false;
        device.sendText = 'Прибор сломан, обратитесь в управляющую организацию';
        device.showCreateTask = true;
      }
      else if (device.next_checking_date !== null && $parseDateFromString(device.next_checking_date) < Date.now()) {
        device.canSend = false;
        device.sendText = 'Истёк срок поверки прибора, обратитесь в управляющую организацию';
        device.showCreateTask = true;
        device.showCreateLeft = true;
      } else if ([5].includes(device.actual_state) || device.is_standard) {

        let checkedDate = device.checked_at ? $parseDateFromString(device.checked_at) : null;

        let isChecked = false;
        if(checkedDate !== null){
          checkedDate = moment(checkedDate).startOf('month').startOf('day').unix();
          let currentMonth = (new Date()).getDate() > 28 ? moment(Date.now()).add(1, 'month').startOf('month').startOf('day').unix() : moment(Date.now()).startOf('month').startOf('day').unix();
          if(currentMonth >= checkedDate){
            isChecked = true;
          }
        }

        if(!isChecked){
          device.canSend = false;
          device.sendText = 'Обратитесь в управляющую компанию чтобы подать показания';
        }
        else{
          device.canSend = true;
          device.sendText = '';
        }
      }
      else if(
          (device.last_real_value_created_at && device.last_real_value_created_at && moment($parseDateFromString(device.last_real_value_created_at.split(" ")[0])).toDate() <= moment(new Date()).subtract(4, "month").toDate()) ||
          (!device.last_real_value_created_at && moment($parseDateFromString(device.operation_start_date)).toDate() <= moment(new Date()).subtract(4, "month").toDate())){
        device.canSend = false;
        device.sendText = 'Необходимо вызвать сотрудника Ук для проверки работоспособности прибора';
        device.showCreateTask = true;
      } else {
        device.canSend = true;
        device.sendText = '';
      }

      if([21].includes(device.type)){
        device.subTitle = "Расход"
      }

      return device;
    });

    let devicesGroups = [];

    let isElectricityGrouped = false;

    let electricityDevices = devicesCanShow.filter(d => [3, 4, 5].includes(d.type));
    let electricityDevicesUnique = [...new Set(electricityDevices.map(d => d.type))];

    if (electricityDevices.length) {
      if (electricityDevicesUnique.length === electricityDevices.length) {
        isElectricityGrouped = true;
        let groupCanSend = true;
        let groupShowCreateTask = false;
        let groupSendText = "";

        if (electricityDevices.filter(d => !d.canSend).length) {
          groupCanSend = false;
          groupSendText = electricityDevices.filter(d => !d.canSend)[0].sendText;
        }

        if (electricityDevices.filter(d => d.showCreateTask).length) {
          groupShowCreateTask= true;
        }

        let group = {
          isGroup: true,
          canSend: groupCanSend,
          sendText: groupSendText,
          icon: 'ElectricityIcon',
          name: "Электричество",
          iconColor: "warning",
          showCreateTask: groupShowCreateTask,
          devices: [],
        };

        electricityDevices.forEach(device => {
          let label = '';

          if (electricityDevices.length !== 1) {
            switch (device.type) {
              case 3:
                label = "День";
                break;
              case 4:
                label = "Ночь";
                break;
              case 5:
                label = "Пик";
                break;
              default:
                label = "";
                break;
            }
          }

          device.label = label;

          group.devices.push(device);

          if (device.showVisualNight) {
            device.label = 'День';
            let nightDevice = Object.assign({}, device);
            nightDevice.label = 'Ночь';
            nightDevice.value = null;

            group.needSum = true;

            group.devices.push(nightDevice);

          }
        });

        devicesGroups.push(group);
      }
    }
    if (isElectricityGrouped) {
      devicesCanShow = devicesCanShow.filter(d => ![3, 4, 5].includes(d.type));
    }

    state.devicesCanSend = [...devicesCanShow, ...devicesGroups];
  },
  SET_DISPLAY_DEVICES(state, payload){
    state.displayDevices = payload;
  },
  SET_LOADING(state, payload = true){
    state.isLoading = payload;
  }
};

export default mutations;
